export const STANDARD_DAY_MONTH_FORMAT = 'DD MMM';
export const STANDARD_DATE_FORMAT = `${STANDARD_DAY_MONTH_FORMAT} YYYY`;
